<template>
  <header
    id="shell.header"
    class="shell-header position-sticky top-0 d-flex flex-shrink-0 align-items-center px-3 border-bottom"
  >
    <aside
      v-if="open === false"
      class="d-flex align-items-center justify-content-between h-100 pe-sm-3"
    >
      <div class="h-100" style="cursor: pointer" @click="$router.push('/')"><LogoEkco /></div>
      <IconButton
        id="shell.header.sidebar-open"
        icon-name="material-symbols:side-navigation"
        variant="ghost"
        size="lg"
        @click="
          open = true;
          peek = false;
        "
        @mouseenter="if (open === false) peek = true;"
      />
    </aside>
    <slot name="sidebar-toggle" />
    <nav class="d-flex align-items-center justify-content-between gap-1 h-100 w-100">
      <div class="flex-grow-1 d-flex align-items-center">
        <SpotlightSearch @navigate="navigate" />
      </div>
      <div class="d-flex align-items-center gap-1 flex-shrink-0">
        <NotificationDropdown />
        <HelpDropdown />
        <IconButton
          id="shell.header.feedback"
          icon-name="material-symbols:feedback-outline"
          size="lg"
          @click="handleFeedbackOpen()"
        />
        <IconButton
          v-if="performanceStore.entries.length > 0"
          id="shell.header.performance"
          icon-name="material-symbols:speed-outline"
          size="lg"
          @click="performanceStore.modalOpen = !performanceStore.modalOpen"
        />
        <SettingsApp />
      </div>
    </nav>
  </header>
</template>
<script setup lang="ts">
import {feedbackOpenKey} from '@/components/shared/custom/FeedbackSlideIn/injectionKeys';
const handleFeedbackOpen = inject(feedbackOpenKey)!;
defineProps<{loading?: boolean}>();
const emit = defineEmits<{
  'toggle-dialog': [value: boolean];
  navigate: [meta: SpherePageMeta<SpherePageType>];
}>();
const performanceStore = usePerformanceStore();

const open = defineModel<boolean>('open', {required: true});
const peek = defineModel<boolean>('peek', {required: true});

const navigate = (meta: SpherePageMeta<SpherePageType>) => emit('navigate', meta);
</script>
<style lang="scss" scoped>
.shell-header {
  height: var(--shell-header-height);
  z-index: 9;
}

:deep(.logo-ekco) {
  height: 100% !important;
  padding: 0.25rem 0;
}
</style>
